import React, { useState } from 'react';
import './SubmitRequest.css';
import { FaSpinner, FaEnvelope, FaPhoneAlt, FaTag, FaCommentAlt, FaExclamationCircle, FaFileUpload } from 'react-icons/fa';
import axios from 'axios';
import { FaUser, FaUserSlash } from 'react-icons/fa';
import { useContext } from "react";
import AlertContext from "../../../contexts/AlertContext";

const SubmitRequest = () => {
  const [formData, setFormData] = useState({
    email: '',
    phone: '',
    subject: '',
    message: '',
    issueType: '',
    description: '',
    file: null,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [formErrors, setFormErrors] = useState({});
  const { showAlert } = useContext(AlertContext);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (value.trim() === '') {
      setFormErrors((prev) => ({ ...prev, [name]: `${name} is required` }));
    } else {
      setFormErrors((prev) => {
        const { [name]: removed, ...rest } = prev;
        return rest;
      });
    }
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, file: e.target.files[0] });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorMessage('');
    setSuccessMessage('');

    const formDataToSubmit = new FormData();
    formDataToSubmit.append('userId', formData.userId);
    formDataToSubmit.append('reportedUserId', formData.reportedUserId);
    formDataToSubmit.append('email', formData.email);
    formDataToSubmit.append('phone', formData.phone);
    formDataToSubmit.append('subject', formData.subject);
    formDataToSubmit.append('issueType', formData.issueType);
    formDataToSubmit.append('description', formData.description);
    formDataToSubmit.append('message', formData.message); // optional
    if (formData.file) formDataToSubmit.append('file', formData.file);
    if (formData.transactionId) formDataToSubmit.append('transactionId', formData.transactionId);

    try {
      const response = await axios.post(
        'https://back.varankal.com/api/submit-request/submit',
        formDataToSubmit,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response.data.success) {
        setSuccessMessage(response.data.message);
        localStorage.setItem('successMessage', response.data.message);

        // ✅ Show alert after successful submission
        showAlert('Your request has been successfully submitted!');

        window.location.href = '/profile'; // redirect
      } else {
        showAlert(response.data.message || 'Submission failed.', "error");
      }
    } catch (error) {
      showAlert('There was an error submitting your request. Please try again.', "error");
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <div className="submit-request-container">
      <h2>Report Inappropriate Activity</h2>
      <form onSubmit={handleSubmit} className="submit-request-form">
        <div className="form-group">
          <label htmlFor="userId"><FaUser className="input-icon" /> Your User ID:</label>
          <input
            type="text"
            id="userId"
            name="userId"
            value={formData.userId}
            onChange={handleChange}
            required
            className="input-field"
            placeholder="Enter your user ID"
          />
        </div>

        <div className="form-group">
          <label htmlFor="email"><FaEnvelope className="input-icon" /> Your Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="input-field"
            placeholder="Enter your email address"
          />
          {formErrors.email && <span className="error">{formErrors.email}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="reportedUserId"><FaUserSlash className="input-icon" /> Reported User ID:</label>
          <input
            type="text"
            id="reportedUserId"
            name="reportedUserId"
            value={formData.reportedUserId}
            onChange={handleChange}
            required
            className="input-field"
            placeholder="Enter the user ID you're reporting"
          />
        </div>

        <div className="form-group">
          <label htmlFor="issueType">
            <FaExclamationCircle className="input-icon" /> Type of Report:
          </label>

          {formData.issueType === "other" ? (
            // Show text input if 'other' is selected
            <input
              type="text"
              id="issueType"
              name="issueType"
              value={formData.issueTypeText || ""}
              onChange={(e) =>
                setFormData((prevData) => ({
                  ...prevData,
                  issueTypeText: e.target.value,
                }))
              }
              className="input-field"
              placeholder="Please specify your issue"
            />
          ) : (
            // Show select dropdown for predefined options
            <select
              id="issueType"
              name="issueType"
              value={formData.issueType}
              onChange={(e) => {
                const value = e.target.value;
                setFormData((prevData) => ({
                  ...prevData,
                  issueType: value,
                  issueTypeText: value === "other" ? "" : value, // store selected or reset
                }));
              }}
              required
              className="input-field"
            >
              <option value="">Select Report Type</option>
              <option value="fake-profile">Fake Profile</option>
              <option value="abusive-behavior">Abusive or Offensive Behavior</option>
              <option value="harassment">Harassment or Threats</option>
              <option value="inappropriate-content">Inappropriate Content</option>
              <option value="fraud">Fraud or Scamming</option>
              <option value="other">Other</option>
            </select>
          )}
        </div>



        {/* <div className="form-group full-width">
          <label htmlFor="message"><FaCommentAlt className="input-icon" /> Your Message:</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            className="input-field"
          ></textarea>
          {formErrors.message && <span className="error">{formErrors.message}</span>}
        </div> */}

        {formData.issueType === 'payment' && (
          <div className="form-group full-width">
            <label htmlFor="transactionId">Transaction ID:</label>
            <input
              type="text"
              id="transactionId"
              name="transactionId"
              value={formData.transactionId || ''}
              onChange={handleChange}
              className="input-field"
            />
          </div>
        )}

        <div className="form-group full-width">
          <label htmlFor="description">Description of Issue:</label>
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Provide more details about your issue (optional)"
            className="input-field"
          ></textarea>
          <div className="char-count">{formData.description.length} / 500</div>
        </div>

        <div className="form-group full-width">
          <label htmlFor="file"><FaFileUpload className="input-icon" /> Upload File (optional):</label>
          <input type="file" id="file" name="file" onChange={handleFileChange} className="input-field" />
        </div>

        <div className="form-group full-width">
          <button type="submit" disabled={isSubmitting} className="submit-button">
            {isSubmitting ? <FaSpinner className="spinner" /> : 'Submit Report'}
          </button>
        </div>

        {successMessage && <div className="success-message full-width">{successMessage}</div>}
        {errorMessage && <div className="error-message full-width">{errorMessage}</div>}
      </form>
    </div>
  );
};

export default SubmitRequest;
